var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icWarning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login---Setup-pwd---email-Error",
    transform: "translate(-60.000000, -298.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(60.000000, 295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5916582,9.80191185 C7.5916582,10.2792371 7.20329152,10.6676038 6.72596629,10.6676038 C6.24864106,10.6676038 5.86027438,10.2792371 5.86027438,9.80191185 L5.86027438,5.82873975 C5.86027438,5.60226998 6.04387783,5.41866653 6.27034761,5.41866653 L7.18163965,5.41866653 C7.4081641,5.41866653 7.59171288,5.60226998 7.59171288,5.82873975 L7.59171288,9.80191185 L7.5916582,9.80191185 Z M6.72596629,13.4775895 C6.2518123,13.4775895 5.86607009,13.0918473 5.86607009,12.6176933 C5.86607009,12.143594 6.2518123,11.7578518 6.72596629,11.7578518 C7.20012029,11.7578518 7.5858625,12.143594 7.5858625,12.6176933 C7.58580782,13.091902 7.20006561,13.4775895 6.72596629,13.4775895 L6.72596629,13.4775895 Z M13.2727579,13.0184168 L7.86996123,3.66054594 C7.63118926,3.24697343 7.20351023,3 6.72591162,3 C6.248313,3 5.82063397,3.24691876 5.58186201,3.66054594 L0.179119983,13.0184168 C-0.059706661,13.4319894 -0.059706661,13.9258269 0.179119983,14.3394541 C0.417946627,14.7530812 0.845570981,15 1.32316959,15 L12.1288177,15 C12.6063616,15 13.0340406,14.7530812 13.2728126,14.3395087 C13.5115846,13.9258815 13.5115299,13.432044 13.2727579,13.0184168 L13.2727579,13.0184168 Z",
    id: "icWarning"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/icWarning.467659caebe84eed966dbf2c91a35fc2.svg";
export { ForwardRef as ReactComponent };